import { useEffect, useState } from 'react'
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons'
import { ButtonRemove, Container, ContainerImage, IconSvg, Image, PdfIcon } from '../styles'
import { ButtonRetry, ProgressText, ScreenLoading, SpinLoading } from './styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { UploadStatus } from '../../../types'

const PreviewImageUpload = ({
  file,
  status,
  progress,
  retryUpload,
  removeSelectFile,
}: {
  file: File
  status?: UploadStatus
  progress?: number
  retryUpload: (file: File) => void
  removeSelectFile: () => void
}) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const isPdf = file.type === 'application/pdf'

  useEffect(() => {
    if (isPdf) {
      setPreviewUrl(IMAGE_URL.minimalDocsIcon)
      return
    }

    const objectUrl = URL.createObjectURL(file)
    setPreviewUrl(objectUrl)

    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file, isPdf])

  return previewUrl ? (
    <Container>
      <ContainerImage>
        {status === 'uploading' && (
          <>
            <ScreenLoading />
            <SpinLoading indicator={<LoadingOutlined spin style={{ fontSize: '40px' }} />} />
            {progress !== undefined && <ProgressText>{progress}%</ProgressText>}
          </>
        )}
        {status === 'retry' && (
          <>
            <ButtonRemove
              shape="circle"
              icon={<IconSvg src={IMAGE_URL.closeWhiteIcon} onClick={removeSelectFile} />}
            />
            <ButtonRetry
              shape="circle"
              icon={<ReloadOutlined />}
              onClick={() => retryUpload(file)}
            />
          </>
        )}
        {isPdf ? (
          <PdfIcon src={IMAGE_URL.minimalDocsIcon} />
        ) : (
          <Image src={previewUrl} />
        )}
      </ContainerImage>
    </Container>
  ) : null
}

export default PreviewImageUpload
